import environment from '@root/core/src/utils/environment';
import { sprig } from '@sprig-technologies/sprig-bundled';

export function initializeSprig() {
  if (environment.sprigEnabled && environment.sprigEnvironmentId) {
    sprig.configure({
      environmentId: environment.sprigEnvironmentId,
    });
  }
}
